import { GetOneSite } from '@/api/fe-api/view/queries/get-one-site';
import { LoadError } from '@/components/ui/load-error';
import { Loading } from '@/components/ui/old/Loading';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';
import { cls } from '@/utils/cls';

import { CardBatteryCellType } from './card-battery-cell-type';
import { CardNbAlerts } from './card-nb-alerts';
import { CardPowerEnergy } from './card-power-energy';
import { CardTasks } from './card-tasks';
import { CardTrippedSystem } from './card-tripped-systems';
import { CardWhiteLabelNbTickets } from './card-white-label-nb-tickets';
import { SiteHero } from './site-hero';

export type SiteDetailsProps = {
  siteId: string;
};
export function SiteDetails({ siteId }: SiteDetailsProps) {
  const me = useMe();
  const site = GetOneSite.useQuery({ id: siteId });
  const featureFlag = useFeatureFlag();
  const showMetadata = featureFlag('recordsMetadata');

  if (site.isLoading) {
    return <Loading />;
  }

  if (site.isError || !site.data) {
    return (
      <LoadError title="An error occurred while loading some site details" />
    );
  }

  if (site.data.isErr()) {
    switch (site.data.error.type) {
      case 'NOT_FOUND': {
        return <p>Site not found</p>;
      }
    }
  }
  return (
    <div data-testid="site-details" className="flex flex-col gap-4">
      <div className="">
        <SiteHero site={site.data.value} />
      </div>
      {me.whiteLabel ? (
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-4">
          <CardTrippedSystem site={site.data.value} />
          {featureFlag('alerts') ? (
            <CardNbAlerts site={site.data.value} />
          ) : null}
          {showMetadata ? (
            <CardTasks site={site.data.value} />
          ) : (
            <>
              <CardPowerEnergy site={site.data.value} />
              <CardBatteryCellType site={site.data.value} />
            </>
          )}
          <CardWhiteLabelNbTickets />
        </div>
      ) : (
        <div
          className={cls('grid grid-cols-1 gap-3 lg:grid-cols-3', {
            'xl:grid-cols-3 2xl:grid-cols-4': !showMetadata,
          })}
        >
          <CardTrippedSystem site={site.data.value} />
          {featureFlag('alerts') ? (
            <CardNbAlerts site={site.data.value} />
          ) : null}
          {showMetadata ? (
            <CardTasks site={site.data.value} />
          ) : (
            <>
              <CardPowerEnergy site={site.data.value} />
              <CardBatteryCellType site={site.data.value} />
            </>
          )}
        </div>
      )}
    </div>
  );
}
